module.exports = __webpack_public_path__ + "img/cash-register.34b0ba20.svg";